// VUE_APP_VERSION 由构建前的 sync-version 脚本从 package.json 同步，供浏览器控制台确认部署版本。
const appVersion = process.env.VUE_APP_VERSION || "unknown";

export function logAppVersion() {
  console.info(`[JoinCompass] Version: v${appVersion}`);
}
